import { render, staticRenderFns } from "./SpaceMeasuresHistory.vue?vue&type=template&id=532edaec"
import script from "./SpaceMeasuresHistory.vue?vue&type=script&lang=js"
export * from "./SpaceMeasuresHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports